import { mapGetters, mapMutations } from "vuex";

// Blocks a record page when the record belongs to another system.
// The SystemRestrictionModal is mounted once in Home.vue and opened through the store.
// Usage:
//   mixins: [systemRestriction],
//   systemRestrictionReload: "fetchOrder", // method called after switching system
//   call checkSystem(record.brand) after fetching, and wrap the page content in
//   <template v-if="!restrictedBrand">
export default {
  data() {
    return {
      // Brand of the fetched record when it belongs to another system
      restrictedBrand: null
    };
  },
  computed: {
    ...mapGetters(["getUserSystem"])
  },
  watch: {
    // User switched to the record's system from the modal: load the record again
    getUserSystem() {
      const reload = this.$options.systemRestrictionReload;
      if (this.restrictedBrand && reload) {
        this[reload]();
      }
    }
  },
  methods: {
    ...mapMutations(["setSystemRestrictionBrand"]),
    // Returns true if the record can be shown; otherwise opens the restriction modal
    checkSystem(brand) {
      const allowed =
        !brand || brand.toLowerCase() === this.getUserSystem.toLowerCase();
      this.restrictedBrand = allowed ? null : brand;
      this.setSystemRestrictionBrand(this.restrictedBrand);
      return allowed;
    }
  },
  beforeDestroy() {
    // Don't leave the modal open on the next page
    if (this.restrictedBrand) {
      this.setSystemRestrictionBrand(null);
    }
  }
};
